export var Button = {
    baseStyle: {
        fontWeight: 500,
    },
};
